module.exports = __webpack_public_path__ + "img/maker_kunhwa.0f00d9de.jpg";